// @ts-nocheck
import { Component } from '@theme/component';

const STORAGE_KEY = 'color-wishlist';

const HEART_SVG =
  '<svg xmlns="http://www.w3.org/2000/svg" width="15" height="14" viewBox="0 0 15 14" fill="none"><path d="M12.1667 8.16666C13.16 7.19333 14.1667 6.02666 14.1667 4.5C14.1667 3.52753 13.7804 2.5949 13.0927 1.90727C12.4051 1.21964 11.4725 0.833328 10.5 0.833328C9.32666 0.833328 8.5 1.16666 7.5 2.16666C6.5 1.16666 5.67333 0.833328 4.5 0.833328C3.52754 0.833328 2.59491 1.21964 1.90727 1.90727C1.21964 2.5949 0.833332 3.52753 0.833332 4.5C0.833332 6.03333 1.83333 7.2 2.83333 8.16666L7.5 12.8333L12.1667 8.16666Z" stroke="currentcolor" stroke-width="var(--icon-stroke-width)" stroke-linecap="round" stroke-linejoin="round"/></svg>';

function getList() {
  try {
    return JSON.parse(localStorage.getItem(STORAGE_KEY) || '[]');
  } catch {
    return [];
  }
}

function setList(list) {
  localStorage.setItem(STORAGE_KEY, JSON.stringify(list));
}

function toArray(val) {
  if (val == null || val === '') return [];
  const s = String(val).trim();
  return s === '' ? [] : s.split(',').map((x) => x.trim()).filter(Boolean);
}

function escapeHtml(str) {
  if (str == null || str === '') return '';
  return String(str)
    .replace(/&/g, '&amp;')
    .replace(/</g, '&lt;')
    .replace(/>/g, '&gt;')
    .replace(/"/g, '&quot;')
    .replace(/'/g, '&#39;');
}

function getItemFromButton(btn) {
  const get = (key) => btn.getAttribute(key) ?? '';
  return {
    url: get('data-colorurl'),
    hexcode: get('data-colorcode'),
    colorId: get('data-colorid'),
    colorName: get('data-colorname'),
    colorRef: get('data-colorref'),
    colorHandle: get('data-colorhandle'),
    description: get('data-colordescription'),
    colorImage: get('data-colorimage'),
    colorBase: get('data-colorbase'),
    colorcollection: toArray(get('data-colorcollection')),
    colorfilter: toArray(get('data-colorfilter')),
    coloratmosphere: toArray(get('data-coloratmosphere')),
    colorcatalog: get('data-colorcatalog'),
  };
}

function isSameItem(item, colorId, colorCode) {
  const idMatch = colorId !== '' && String(item.colorId) === String(colorId);
  const codeMatch = colorCode !== '' && String(item.hexcode) === String(colorCode);
  return idMatch || codeMatch;
}

function isInList(list, colorId, colorCode) {
  return list.some((item) => isSameItem(item, colorId, colorCode));
}

function addItem(item) {
  const list = getList();
  if (isInList(list, item.colorId, item.hexcode)) return;
  list.push(item);
  setList(list);
  window.dispatchEvent(new CustomEvent('wishlist-updated'));
}

function removeItem(colorId, colorCode) {
  const list = getList();
  const index = list.findIndex((i) => isSameItem(i, colorId, colorCode));
  if (index === -1) return;
  list.splice(index, 1);
  setList(list);
  window.dispatchEvent(new CustomEvent('wishlist-updated'));
}

function itemToDataAttrs(item) {
  const join = (arr) => (Array.isArray(arr) ? arr.join(', ') : String(arr || ''));
  return [
    `data-colorcode="${escapeHtml(item.hexcode || '')}"`,
    `data-colorid="${escapeHtml(item.colorId || '')}"`,
    `data-colorurl="${escapeHtml(item.url || '')}"`,
    `data-colorname="${escapeHtml(item.colorName || '')}"`,
    `data-colorref="${escapeHtml(item.colorRef || '')}"`,
    `data-colorbase="${escapeHtml(item.colorBase || '')}"`,
    `data-colorhandle="${escapeHtml(item.colorHandle || '')}"`,
    `data-colorimage="${escapeHtml(item.colorImage || '')}"`,
    `data-colordescription="${escapeHtml(item.description || '')}"`,
    `data-colorcollection="${escapeHtml(join(item.colorcollection))}"`,
    `data-colorfilter="${escapeHtml(join(item.colorfilter))}"`,
    `data-coloratmosphere="${escapeHtml(join(item.coloratmosphere))}"`,
    `data-colorcatalog="${escapeHtml(item.colorcatalog || '')}"`,
  ].join(' ');
}

function updateWishlistCount() {
  const bar = document.querySelector('[data-wishlist-bar]');
  const countEl = document.querySelector('[data-wishlist-count]');
  if (!bar || !countEl) return;
  const count = getList().length;
  const labelOne = bar.getAttribute('data-wishlist-label-one') || 'item';
  const labelOther = bar.getAttribute('data-wishlist-label-other') || 'items';

  // Always show an accurate count, including when there are 0 items.
  // This keeps the UI in sync when the last item is removed.
  bar.hidden = false;
  if (count === 0) {
    countEl.textContent = `0 ${labelOther}`;
  } else {
    countEl.textContent = count === 1 ? `1 ${labelOne}` : `${count} ${labelOther}`;
  }
}

function renderWishlistPage() {
  const listEl = document.querySelector('[data-wishlist-list]');
  const emptyEl = document.querySelector('[data-wishlist-empty]');
  if (!listEl) return;

  // Show most recently added items first
  const list = getList().slice().reverse();
  if (emptyEl) emptyEl.hidden = list.length > 0;

  listEl.innerHTML = '';
  list.forEach((item) => {
    const url = (item.url || '').trim() || '#';
    const colorNameRaw = item.colorName || '';
    const colorName = escapeHtml(colorNameRaw);
    const hexcodeRaw = (item.hexcode || '').trim() || '#f5f5f5';
    // Wishlist card title should only show the color name (no hex code).
    const firstLineRaw = colorNameRaw || hexcodeRaw;
    const collectionText = Array.isArray(item.colorcollection)
      ? item.colorcollection.join(', ')
      : String(item.colorcollection || '');
    const dataAttrs = itemToDataAttrs(item);
    const card = document.createElement('div');
    card.className = 'wishlist-color-card-wrapper';
    card.innerHTML =
      '<div class="wishlist-color-card">' +
      `<a href="${url}" aria-label="${colorName}" class="wishlist-colorCard-link"></a>` +
      '<div class="wishlist-color-card__swatch">' +
      `<div class="wishlist-color-card__swatch-color" style="background-color: ${hexcodeRaw};" aria-label="Color swatch for ${colorName}"></div>` +
      '<div class="wishlist-color-card__icons">' +
      '<wishlist-button>' +
      `<button type="button" ref="trigger" class="wishlist-color-card__heart-button" aria-label="Remove from favorites" ${dataAttrs}>${HEART_SVG}</button>` +
      '</wishlist-button>' +
      '</div></div>' +
      '<div class="wishlist-color-card__content">' +
      '<div class="wishlist-color-content-wrap"><div class="wishlist-color-content-wrap-inner">' +
      `<div class="wishlist-color-card__name wishlist-color-card__name--medium"><h3 class="wishlist-color-card__name-text">${escapeHtml(firstLineRaw)}</h3></div>` +
      '<div class="wishlist-color-card__collection">' +
      `<p class="wishlist-color-card__collection-text">${escapeHtml(collectionText)}</p>` +
      '</div></div></div></div></div>';
    listEl.appendChild(card);
  });
  updateWishlistCount();
}

class WishlistButtonComponent extends Component {
  requiredRefs = ['trigger'];

  connectedCallback() {
    super.connectedCallback();
    const trigger = this.refs?.trigger ?? this.querySelector('button');
    if (!trigger) return;
    this._trigger = trigger;
    trigger.addEventListener('click', this.#handleClick);
    this.#syncFillClass();

    // Keep this button in sync with global wishlist changes so that
    // multiple instances of the same color update together.
    this._handleWishlistUpdated = () => this.#syncFillClass();
    window.addEventListener('wishlist-updated', this._handleWishlistUpdated);
  }

  disconnectedCallback() {
    super.disconnectedCallback();
    if (this._trigger) this._trigger.removeEventListener('click', this.#handleClick);
    if (this._handleWishlistUpdated) {
      window.removeEventListener('wishlist-updated', this._handleWishlistUpdated);
    }
  }

  #syncFillClass() {
    if (!this._trigger) return;
    const colorId = this._trigger.getAttribute('data-colorid') || '';
    const colorCode = this._trigger.getAttribute('data-colorcode') || '';
    this._trigger.classList.toggle('wishlist-fill', isInList(getList(), colorId, colorCode));
  }

  #handleClick = (e) => {
    e.preventDefault();
    e.stopPropagation();
    if (!this._trigger) return;
    const colorId = this._trigger.getAttribute('data-colorid') ?? '';
    const colorCode = this._trigger.getAttribute('data-colorcode') ?? '';
    if (!colorId && !colorCode) return;
    const list = getList();
    if (isInList(list, colorId, colorCode)) {
      removeItem(colorId, colorCode);
    } else {
      addItem(getItemFromButton(this._trigger));
    }
    this.#syncFillClass();
  };
}

customElements.define('wishlist-button', WishlistButtonComponent);

function initWishlistPage() {
  if (document.querySelector('[data-wishlist-list]')) renderWishlistPage();
}

if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', initWishlistPage);
} else {
  initWishlistPage();
}
window.addEventListener('wishlist-updated', renderWishlistPage);
